import React, { useContext, useEffect } from "react";
import Login from "../components/Auth/Login";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { AuthContext } from "../contexts/AuthContext";
import { navigate, useNavigate } from "react-router-dom";

function LoginPage() {
  const { isAuthenticated} = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/profile")
    }
  }, []);
  return (
    <>
    <Navbar/>
  { !isAuthenticated && <div className="flex flex-col justify-center items-center gap-2 p-4 container">
        <h1 className="font-secondaryFont">Welcome To Login Page</h1>
        <div className="border-2 hover:shadow-lg p-2 rounded-full text-5xl">
        <Login  />
        </div>
        <h1 className="font-secondaryFont">Click here For Login</h1>
        <h2 className="font-primaryFont">Wait For 1 Min After Login To Load Backend Data</h2>
    </div>}
    <Footer/>
    </>
  );
}

export default LoginPage;
